import React, { useState, useRef, useEffect } from 'react'
import { colors } from '../../../colors'
import { BetButton, BetButtonsWrapper } from './BetButtonsStyles'
import { useButtonSounds } from './helpers/betButtonSounds'
import { HandleButtonContent } from './helpers/HandleButtonsContent'
import handleLeftActions from './helpers/leftButtonActions'
import { BET_BUTTON_PROPS } from './interface'
import { replaceThousand } from '../helpers/helperChip'

export default function BetButtons({
  betButtonVariables,
  betButtonHandlers,
  isDealing,
  setisDealing,
}: BET_BUTTON_PROPS) {
  const { currency, anteStake, precision, state, audio } = betButtonVariables
  const {
    handleUndo,
    handleClearStake,
    handleFoldAndDealOut,
    handleDealOut,
    texasSocketMessages,
    clearStakes,
  } = betButtonHandlers

  const { UNDO, DEAL } = HandleButtonContent(
    state,
    anteStake,
    currency,
    precision,
  )
  const leftColor = state === 0 ? colors.secondary : colors.quaternary

  const [buttonPressMoment, setbuttonPressMoment] = useState<number | null>(0)
  const [isClickable, setIsClickable] = useState<boolean>(false)

  const timer = useRef<any>()
  const sfxs = useButtonSounds(audio)

  useEffect(() => {
    if (
      (state === 0 || state === 5 || state === 6 || state === 11) &&
      buttonPressMoment
    ) {
      timer.current = setTimeout(() => {
        handleClearStake()
        audio?.sound && sfxs.playClearSFX()
      }, 500)
    }
  }, [buttonPressMoment])

  const handleButtonPressMoment = () => {
    setbuttonPressMoment(Date.now())
  }

  const handleLongPress = () => {
    clearTimeout(timer.current)
    setbuttonPressMoment(null)
  }

  const clickhandler = (ante: string) => {
    const anteStake = ante.toString().includes('k')
      ? replaceThousand(ante).toString()
      : ante
    switch (state) {
      case 0:
        setisDealing(true)
        texasSocketMessages.handleDeal(anteStake, '0')
        audio?.sound && sfxs.playDealSFX()
        break
      case 4:
        setisDealing(true)
        texasSocketMessages.handleRaise()
        audio?.sound && sfxs.playRaiseSFX()
        break
      case 5:
      case 6:
      case 11:
        handleDealOut()
        clearStakes()
        setisDealing(true)
        audio?.sound && sfxs.playDealSFX()
        setTimeout(() => {
          texasSocketMessages.handleDeal(anteStake, '0')
        }, 1000)
        break
      case 14:
      case 15:
        setisDealing(true)
        texasSocketMessages.handleBet()
        audio?.sound && sfxs.playBetSFX()
        break
      default:
        break
    }
  }

  return (
    <BetButtonsWrapper>
      <BetButton
        isDisabled={isDealing || anteStake === '0' || isClickable}
        leftColor={leftColor}
        leftButton
        onClick={() =>
          handleLeftActions(
            audio,
            state,
            handleUndo,
            handleFoldAndDealOut,
            texasSocketMessages.handleCheck,
            sfxs.playUndoSFX,
            sfxs.playFoldlSFX,
            sfxs.playCheckSFX,
            setIsClickable,
          )
        }
        onMouseDown={handleButtonPressMoment}
        onMouseUp={handleLongPress}
        onTouchStart={handleButtonPressMoment}
        onTouchEnd={handleLongPress}
      >
        <div className='btn'>{UNDO}</div>
        <div className='white' />
      </BetButton>
      <BetButton
        isDisabled={isDealing || anteStake === '0'}
        onClick={() => clickhandler(anteStake)}
      >
        <div className='btn'>{DEAL}</div>
        <div className='white' />
      </BetButton>
    </BetButtonsWrapper>
  )
}
